import { render, staticRenderFns } from "./family-form-page.vue?vue&type=template&id=2e5d104b&"
import script from "./family-form-page.vue?vue&type=script&lang=js&"
export * from "./family-form-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports